import { render } from "./TheTokushoho.vue?vue&type=template&id=81e3129e&scoped=true"
const script = {}

import "./TheTokushoho.vue?vue&type=style&index=0&id=81e3129e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81e3129e"]])

export default __exports__